import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
import { CommentsListWrapper, CountTitle, ShowMoreButton, } from "../../styles";
import { useDispatch, useSelector } from "react-redux";
import { API } from "@brg/api";
import { useProfile } from "@brg/auth";
import useLocalization from "../../../../../hooks/useLocalization";
import { fetchMoreChatData, onUpdateChatState } from "../../../../../actions/chatActions";
import { getChat } from "../../../../../reducers/chatReducer";
import { useScrollByMsg } from "../../../../../hooks/useScrollByMsg";
import { LoaderSpinner } from "../support/LoaderSpinner";
import { commentDeckl } from "../support/CommentDeckl";
import useCommonProps from "../../../../../hooks/useCommonProps";
import CommentPost from "../post/CommentPost";
import { COMMENT_INIT_OFFSET, COMMENT_OFFSET, COMMENTS_ALLOWED_TYPE } from "../../const/const";
import { FlexBox, Skeleton } from "@brg/ui";
import { CommentCount } from "../../assets/CommentCount";
var CommentsList = function (_a) {
    var handlers = _a.handlers, onUpdate = _a.onUpdate, time = _a.time, postHidden = _a.postHidden, postEntityId = _a.postEntityId, toggleHidden = _a.toggleHidden;
    var profile = useProfile();
    var t = useLocalization().t;
    var scrollRef = useRef(null);
    var dispatch = useDispatch();
    var language = useCommonProps().language;
    var _b = useState(null), scrollContainer = _b[0], setScrollContainer = _b[1];
    var _c = useState(false), initialLoaded = _c[0], setInitialLoaded = _c[1];
    var _d = useState(true), hasMore = _d[0], setHasMore = _d[1];
    var _e = useSelector(function (store) { return getChat(store); }), postMessages = _e.posts, filter = _e.filter, creatingId = _e.creatingId, isScrolling = _e.isScrolling, loading = _e.loading, permissions = _e.permissions, editorVisible = _e.editorVisible;
    var calcData = useMemo(function () {
        var _a;
        return ((_a = postMessages === null || postMessages === void 0 ? void 0 : postMessages.find(function (_a) {
            var entityId = _a.entityId;
            return entityId === postEntityId;
        })) === null || _a === void 0 ? void 0 : _a.pageModel) || undefined;
    }, [postMessages, postEntityId, time]);
    var data = useMemo(function () {
        return (calcData === null || calcData === void 0 ? void 0 : calcData.data) || undefined;
    }, [calcData, time]);
    var paging = useMemo(function () { return ((calcData === null || calcData === void 0 ? void 0 : calcData.paging) || undefined); }, [calcData]);
    useScrollByMsg();
    var posts = useMemo(function () {
        if (!data)
            return null;
        // const computeItems = data?.map((i) => API.toLang(i, language));
        var computeItems = data;
        return computeItems === null || computeItems === void 0 ? void 0 : computeItems.map(function (comment, index) { return (React.createElement(CommentPost, { comment: comment, key: comment.id, order: index, handlers: handlers, entityId: comment === null || comment === void 0 ? void 0 : comment.entityId, postEntityId: postEntityId, tooltipProps: permissions, creatingId: creatingId, postHidden: postHidden })); });
    }, [
        language,
        postHidden,
        loading,
        time,
        creatingId,
        postEntityId,
        permissions,
        data,
        handlers,
        profile
    ]);
    var loader = useMemo(function () {
        return (React.createElement("div", null, t('loading')));
    }, [loading]);
    var hasMoreVisible = useMemo(function () {
        if ((permissions === null || permissions === void 0 ? void 0 : permissions.entityType) === COMMENTS_ALLOWED_TYPE.post && !postHidden) {
            return (paging === null || paging === void 0 ? void 0 : paging.pages) > (paging === null || paging === void 0 ? void 0 : paging.page) && (data === null || data === void 0 ? void 0 : data.length) >= COMMENT_OFFSET;
        }
        return false;
    }, [permissions, paging, postHidden]);
    var hideMoreVisible = useMemo(function () {
        return (paging === null || paging === void 0 ? void 0 : paging.pages) > 1 && (paging === null || paging === void 0 ? void 0 : paging.pages) === (paging === null || paging === void 0 ? void 0 : paging.page) && (data === null || data === void 0 ? void 0 : data.length) === (paging === null || paging === void 0 ? void 0 : paging.count) && !postHidden;
    }, [paging, data, postHidden]);
    var getMore = function () {
        if (isScrolling)
            return;
        if ((paging === null || paging === void 0 ? void 0 : paging.pages) > paging.page) {
            dispatch(fetchMoreChatData({
                entityId: postEntityId,
                entityType: permissions === null || permissions === void 0 ? void 0 : permissions.entityType,
                page: paging.page + 1,
                offset: paging.offset + COMMENT_OFFSET
            }));
        }
    };
    useEffect(function () {
        return function () {
            dispatch(onUpdateChatState({
                creatingId: null
            }));
        };
    }, []);
    if (!(posts === null || posts === void 0 ? void 0 : posts.length)) {
        return null;
    }
    return (React.createElement(CommentsListWrapper, { width: "100%", direction: "column", directionMobile: "column" },
        React.createElement("div", { className: "switcher_button_portal_".concat(postEntityId) }),
        (posts === null || posts === void 0 ? void 0 : posts.length) ? (React.createElement(InfiniteScroll, { ref: scrollRef, className: 'notification-inf-scroll', dataLength: posts === null || posts === void 0 ? void 0 : posts.length, next: getMore, 
            //@ts-ignore
            // hasMore={paging?.pages > paging.page}
            hasMore: false, loader: loader, scrollableTarget: scrollContainer, initialScrollY: 0, scrollThreshold: 0.8 }, posts)) : loading ? (React.createElement(LoaderSpinner, { hideText: true })) : null,
        hasMoreVisible && (React.createElement(FlexBox, { offsetBottom: 24, width: '100%', align: 'center', justify: 'center' },
            React.createElement(ShowMoreButton, { autoWidth: true, onClick: getMore }, t('chat.load_more')))),
        hideMoreVisible && (React.createElement(FlexBox, { offsetBottom: 24, width: '100%', align: 'center', justify: 'center' },
            React.createElement(ShowMoreButton, { autoWidth: true, onClick: toggleHidden }, t('chat.hide_comments_list'))))));
};
export default CommentsList;
//# sourceMappingURL=CommentList.js.mapimport React, { FC, useEffect, useMemo, useRef, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
import { CommentsListWrapper, CountTitle, ShowMoreButton, } from "../../styles";
import { useDispatch, useSelector } from "react-redux";
import { API } from "@brg/api";
import { useProfile } from "@brg/auth";
import useLocalization from "../../../../../hooks/useLocalization";
import { fetchMoreChatData, onUpdateChatState } from "../../../../../actions/chatActions";
import { getChat } from "../../../../../reducers/chatReducer";
import { useScrollByMsg } from "../../../../../hooks/useScrollByMsg";
import { LoaderSpinner } from "../support/LoaderSpinner";
import { commentDeckl } from "../support/CommentDeckl";
import useCommonProps from "../../../../../hooks/useCommonProps";
import CommentPost from "../post/CommentPost";
import { COMMENT_INIT_OFFSET, COMMENT_OFFSET, COMMENTS_ALLOWED_TYPE } from "../../const/const";
import { FlexBox, Skeleton } from "@brg/ui";
import { CommentCount } from "../../assets/CommentCount";
var CommentsList = function (_a) {
    var handlers = _a.handlers, onUpdate = _a.onUpdate, time = _a.time, postHidden = _a.postHidden, postEntityId = _a.postEntityId, toggleHidden = _a.toggleHidden;
    var profile = useProfile();
    var t = useLocalization().t;
    var scrollRef = useRef(null);
    var dispatch = useDispatch();
    var language = useCommonProps().language;
    var _b = useState(null), scrollContainer = _b[0], setScrollContainer = _b[1];
    var _c = useState(false), initialLoaded = _c[0], setInitialLoaded = _c[1];
    var _d = useState(true), hasMore = _d[0], setHasMore = _d[1];
    var _e = useSelector(function (store) { return getChat(store); }), postMessages = _e.posts, filter = _e.filter, creatingId = _e.creatingId, isScrolling = _e.isScrolling, loading = _e.loading, permissions = _e.permissions, editorVisible = _e.editorVisible;
    var calcData = useMemo(function () {
        var _a;
        return ((_a = postMessages === null || postMessages === void 0 ? void 0 : postMessages.find(function (_a) {
            var entityId = _a.entityId;
            return entityId === postEntityId;
        })) === null || _a === void 0 ? void 0 : _a.pageModel) || undefined;
    }, [postMessages, postEntityId, time]);
    var data = useMemo(function () {
        return (calcData === null || calcData === void 0 ? void 0 : calcData.data) || undefined;
    }, [calcData, time]);
    var paging = useMemo(function () { return ((calcData === null || calcData === void 0 ? void 0 : calcData.paging) || undefined); }, [calcData]);
    useScrollByMsg();
    var posts = useMemo(function () {
        if (!data)
            return null;
        // const computeItems = data?.map((i) => API.toLang(i, language));
        var computeItems = data;
        return computeItems === null || computeItems === void 0 ? void 0 : computeItems.map(function (comment, index) { return (React.createElement(CommentPost, { comment: comment, key: comment.id, order: index, handlers: handlers, entityId: comment === null || comment === void 0 ? void 0 : comment.entityId, postEntityId: postEntityId, tooltipProps: permissions, creatingId: creatingId, postHidden: postHidden })); });
    }, [
        language,
        postHidden,
        loading,
        time,
        creatingId,
        postEntityId,
        permissions,
        data,
        handlers,
        profile
    ]);
    var loader = useMemo(function () {
        return (React.createElement("div", null, t('loading')));
    }, [loading]);
    var hasMoreVisible = useMemo(function () {
        if ((permissions === null || permissions === void 0 ? void 0 : permissions.entityType) === COMMENTS_ALLOWED_TYPE.post && !postHidden) {
            return (paging === null || paging === void 0 ? void 0 : paging.pages) > (paging === null || paging === void 0 ? void 0 : paging.page) && (data === null || data === void 0 ? void 0 : data.length) >= COMMENT_OFFSET;
        }
        return false;
    }, [permissions, paging, postHidden]);
    var hideMoreVisible = useMemo(function () {
        return (paging === null || paging === void 0 ? void 0 : paging.pages) > 1 && (paging === null || paging === void 0 ? void 0 : paging.pages) === (paging === null || paging === void 0 ? void 0 : paging.page) && (data === null || data === void 0 ? void 0 : data.length) === (paging === null || paging === void 0 ? void 0 : paging.count) && !postHidden;
    }, [paging, data, postHidden]);
    var getMore = function () {
        if (isScrolling)
            return;
        if ((paging === null || paging === void 0 ? void 0 : paging.pages) > paging.page) {
            dispatch(fetchMoreChatData({
                entityId: postEntityId,
                entityType: permissions === null || permissions === void 0 ? void 0 : permissions.entityType,
                page: paging.page + 1,
                offset: paging.offset + COMMENT_OFFSET
            }));
        }
    };
    useEffect(function () {
        return function () {
            dispatch(onUpdateChatState({
                creatingId: null
            }));
        };
    }, []);
    if (!(posts === null || posts === void 0 ? void 0 : posts.length)) {
        return null;
    }
    return (React.createElement(CommentsListWrapper, { width: "100%", direction: "column", directionMobile: "column" },
        React.createElement("div", { className: "switcher_button_portal_".concat(postEntityId) }),
        (posts === null || posts === void 0 ? void 0 : posts.length) ? (React.createElement(InfiniteScroll, { ref: scrollRef, className: 'notification-inf-scroll', dataLength: posts === null || posts === void 0 ? void 0 : posts.length, next: getMore, 
            //@ts-ignore
            // hasMore={paging?.pages > paging.page}
            hasMore: false, loader: loader, scrollableTarget: scrollContainer, initialScrollY: 0, scrollThreshold: 0.8 }, posts)) : loading ? (React.createElement(LoaderSpinner, { hideText: true })) : null,
        hasMoreVisible && (React.createElement(FlexBox, { offsetBottom: 24, width: '100%', align: 'center', justify: 'center' },
            React.createElement(ShowMoreButton, { autoWidth: true, onClick: getMore }, t('chat.load_more')))),
        hideMoreVisible && (React.createElement(FlexBox, { offsetBottom: 24, width: '100%', align: 'center', justify: 'center' },
            React.createElement(ShowMoreButton, { autoWidth: true, onClick: toggleHidden }, t('chat.hide_comments_list'))))));
};
export default CommentsList;
//# sourceMappingURL=CommentList.js.map